import { render, staticRenderFns } from "./RequestTokenPage.vue?vue&type=template&id=5ab4ce3a&"
import script from "./RequestTokenPage.vue?vue&type=script&lang=js&"
export * from "./RequestTokenPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
